export default "__VITE_ASSET__wZ7WcDtE__"